<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <div :style="getColorIconStyle(colorToHex())"></div>
      <v-text-field v-model="model" class="schema-name-input" label="Kolor" @change="$emit('input', model)"
                    v-on="on"></v-text-field>
    </template>

    <v-container style="background-color: #ffffff">
      <color-picker v-bind="model" @input="(hue) => onInput(hue, hex => model = hex)"></color-picker>
    </v-container>
  </v-menu>
</template>

<script>
import Color from '@/mixins/color'
import ColorPicker from '@radial-color-picker/vue-color-picker'

export default {
  name: "CalendarData",
  components: {ColorPicker},
  mixins: [Color],
  data() {
    return {
      model: null
    }
  }
}
</script>

<style scoped>

</style>